import { LandXMLLoadingOverlay } from '@/components/LandXMLLoadingOverlay';
import { ModelLoadingOverlay } from '@/components/ModelLoadingOverlay';
import { SplatLoadingOverlay } from '@/components/SplatLoadingOverlay';
import { LoadingBadgeKeyframes } from '@/components/ui/LoadingBadge';

/**
 * One top-centre column for every layer-loading badge in the viewer, so
 * splat, LandXML and model rows stack instead of each loader pinning itself
 * at its own fixed offset and overlapping the others. `pointer-events-none`
 * so it never steals interaction from the canvas.
 */
export const ViewerLoadingColumn = () => (
  <div className='pointer-events-none absolute top-4 left-1/2 z-50 flex -translate-x-1/2 flex-col gap-1.5'>
    <SplatLoadingOverlay />
    <LandXMLLoadingOverlay />
    <ModelLoadingOverlay />
    <LoadingBadgeKeyframes />
  </div>
);
